"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lucide_1 = require("lucide");
const motc_1 = require("@/motc");
const i18n_1 = require("@/common/i18n");
const modal_1 = require("./modal");
const inputLabelText = (0, i18n_1.$)("modal.import.label");
class ImportModal extends modal_1.Modal {
    constructor(target) {
        super(target, { id: "import", title: (0, i18n_1.$)("modal.import.title"), icon: lucide_1.Import });
        this._renderer = null;
        this._rawMot = null;
        this._loadButton = this._addFooterButton("load", { text: (0, i18n_1.$)("modal.import.load"), variant: "success", icon: lucide_1.Import, disabled: true }, "right", () => this._loadFile());
        this._clearButton = this._addFooterButton("clear", { text: (0, i18n_1.$)("modal.import.clear"), disabled: true }, "right", () => this._clear());
        // UI
        const inputContainer = this._container.appendChild((0, jsx_runtime_1.jsx)("div", { className: "file-input-container" }));
        this._inputLabel = inputContainer.appendChild((0, jsx_runtime_1.jsx)("label", { children: (0, jsx_runtime_1.jsx)("span", { className: "file-input-label", children: inputLabelText }) }));
        this._inputElem = this._inputLabel.appendChild((0, jsx_runtime_1.jsx)("input", { type: "file", accept: ".mot", multiple: "false" }));
        this._inputElem.addEventListener("change", () => __awaiter(this, void 0, void 0, function* () {
            if (this._inputElem.files.length === 0)
                return;
            this._importFile(this._inputElem.files[0]);
        }));
        this._inputLabel.addEventListener("drop", (e) => {
            e.preventDefault();
            this._importFile(e.dataTransfer.files[0]);
        });
        this._inputLabel.addEventListener("dragover", (e) => e.preventDefault());
        this._register(this.onShow(({ renderer }) => {
            this._renderer = renderer;
        }));
        this._register(this.onClose(() => {
            this._clear();
        }));
    }
    _importFile(motFile) {
        return __awaiter(this, void 0, void 0, function* () {
            // convert to string
            this._rawMot = yield motFile.text();
            this._setLabel(motFile.name, true);
            this._clearButton.disabled = this._loadButton.disabled = false;
        });
    }
    _loadFile() {
        if (!this._renderer)
            throw new Error("No renderer is provided.");
        if (!this._rawMot)
            throw new Error("No mot file to load.");
        const parsed = motc_1.MOTC.parse(this._rawMot);
        const executor = new motc_1.Executor(this._renderer);
        executor.execute(parsed);
    }
    _clear() {
        this._rawMot = null;
        this._inputElem.value = "";
        this._setLabel(inputLabelText);
        this._clearButton.disabled = this._loadButton.disabled = true;
    }
    _setLabel(text, active = false) {
        const elem = this._inputLabel.getElementsByClassName("file-input-label")[0];
        if (active && !elem.classList.contains("active")) {
            elem.classList.add("active");
        }
        else if (!active) {
            elem.classList.remove("active");
        }
        elem.textContent = text;
    }
}
exports.ImportModal = ImportModal;
